import _ from 'lodash'
import { i18nCategoryResourceType } from '@/store/creative/common/category'

const cookPackI18n = (i18n, category) => {
  if (!i18n || !category) return null

  const cloneI18n = _.cloneDeep(i18n)

  // 打包的 i18n 配置与原始 i18n 配置有区别，如分类隐藏时，原始 i18n value 有值，打包的 i18n 配置 value 为空
  const editI18n = (prefix) => {
    _.each(cloneI18n.languages, language => {
      _.each(language, (languageItem, key) => {
        if (
          // 横竖屏使用相同配置
          key === prefix ||
          // 横竖屏分开配置
          [`${prefix}_V`, `${prefix}_H`].includes(key)
        ) {
          languageItem.value = ''
        }
      })
    })
  }

  const rec = list => {
    _.each(list, item => {
      // 组特别处理，因为组当做一个整体
      if (
        item.resource_type === 'group' &&
        Array.isArray(item.sub_category) &&
        _.get(item, 'properties.visible') === 2
      ) {
        _.each(item.sub_category, groupItem => {
          editI18n(groupItem.prefix)
        })
        return
      }

      // 子类
      if (Array.isArray(item.sub_category)) {
        rec(item.sub_category)
        return
      }

      // 找到隐藏的代码字分类，并将其值修改为空字符串
      if (
        item.resource_type === i18nCategoryResourceType &&
        _.get(item, 'properties.visible') === 2
      ) {
        editI18n(item.prefix)
      }
    })
  }

  rec(category)

  return cloneI18n
}

export default cookPackI18n
